module.exports = __webpack_public_path__ + "static/img/2-100w.5b6e113.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/two/2-100w.png
// module id = qJk+
// module chunks = 1